import { render } from "./ChatSidebar.vue?vue&type=template&id=d841834e&scoped=true"
import script from "./ChatSidebar.vue?vue&type=script&lang=js"
export * from "./ChatSidebar.vue?vue&type=script&lang=js"

import "./ChatSidebar.vue?vue&type=style&index=0&id=d841834e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d841834e"]])

export default __exports__